import api from './axios';

export const getAgendaTags = () => api.get('/agenda-tags');
export const createAgendaTag = (label, color) => api.post('/agenda-tags', { label, color });
export const updateAgendaTag = (id, data) => api.put(`/agenda-tags/${id}`, data);
export const deleteAgendaTag = (id) => api.delete(`/agenda-tags/${id}`);
